import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import {
  GetTodayConditionInputDetailDto,
  PutTodayConditionInputDto,
} from '../../../../dataAccess/webApi/dto/reservationsDto'

interface FacilityReserveTodayConditionInputState {
  reservationInfo?: GetTodayConditionInputDetailDto['reservationInfo']
  todayConditionInputFieldsInfo?: GetTodayConditionInputDetailDto['todayConditionInputFieldsInfo']
  input?: PutTodayConditionInputDto
}

const initialState: FacilityReserveTodayConditionInputState = {}

export const facilityReserveTodayConditionInputSlice = createSlice({
  name: 'facilityReserveTodayConditionInput',
  initialState,
  reducers: {
    setReservationInfo: (state, action: PayloadAction<GetTodayConditionInputDetailDto['reservationInfo']>) => {
      state.reservationInfo = action.payload
    },
    clearReservationInfo: (state) => {
      delete state.reservationInfo
    },
    setTodayConditionInputFieldsInfo: (state, action: PayloadAction<GetTodayConditionInputDetailDto['todayConditionInputFieldsInfo']>) => {
      state.todayConditionInputFieldsInfo = action.payload
    },
    clearTodayConditionInputFieldsInfo: (state) => {
      delete state.todayConditionInputFieldsInfo
    },
    setInput: (state, action: PayloadAction<PutTodayConditionInputDto>) => {
      state.input = action.payload
    },
    clearInput: (state) => {
      delete state.input
    },
  },
})

export const {
  setReservationInfo,
  clearReservationInfo,
  setTodayConditionInputFieldsInfo,
  clearTodayConditionInputFieldsInfo,
  setInput,
  clearInput
} = facilityReserveTodayConditionInputSlice.actions
export const selectInput = (state: RootState) => state.facilityReserveTodayConditionInput.input
export const selectReservationInfo = (state: RootState) => state.facilityReserveTodayConditionInput.reservationInfo
export const selectTodayConditionInputFieldsInfo = (state: RootState) => state.facilityReserveTodayConditionInput.todayConditionInputFieldsInfo
export default facilityReserveTodayConditionInputSlice.reducer
